import * as React from 'react';
import { Subtitle } from './OrderDetail';
import { TextP } from '../../../..';
import styled from 'styled-components';
import { rem } from 'polished';

interface Props {
  title: string;
  company: string;
  street: string;
  streetNr: string;
  city: string;
  psc: string;
}

function Address(props) {
  const { title, company, street, streetNr, city, psc } = props;
  return (
    <>
      <Subtitle marginBottom={32}>{title}</Subtitle>
      {!!company && <StyledText>{company || ''}</StyledText>}
      <TextP>{`${street || ''}${streetNr ? ` ${streetNr}` : ''}, ${city ||
        ''} ${psc || ''}`}</TextP>
    </>
  );
}

const StyledText = styled(TextP)`
  margin-bottom: ${rem(16)};
`;

export { Address as DsiAddress };
